import React from 'react';
import ReactDOM from 'react-dom';
// import {Router, Switch, Route } from 'react-router';
import {HashRouter } from 'react-router-dom'
import injectTapEventPlugin from 'react-tap-event-plugin';
import createBrowserHistory from 'history/createBrowserHistory'

import App from './components/App';

window.React = React;
window.Perf = require('react-addons-perf');

injectTapEventPlugin();

const history = createBrowserHistory()

ReactDOM.render(
  <HashRouter history={history}
    onUpdate={() => window.scrollTo(0, 0)}>
    <App/>
  </HashRouter>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js